import {
  GET_HOTSPOT_DATA,
  SET_HOTSPOT_DATA,
} from "../constants/hotspotdata-constants";

export const getHotspotData = () => ({
  type: GET_HOTSPOT_DATA,
});

export const setHotspotData = (data) => ({
  type: SET_HOTSPOT_DATA,
  data,
});
